exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home{background-color:#ffcb8b;height:100%;padding-top:80px}.home--innerContainer{margin:30px 20px;border:1px solid #c76b00;background-color:#ffb122;border-radius:5px;color:#fff;padding:60px}.home--row{margin-top:40px}.home--heading1{font-size:36px;font-weight:700;padding:0;margin:0}.home--article1,.home--heading1{font-family:Open Sans,sans-serif;color:#000}.home--article1{font-size:18px;margin-top:20px}.home--heading2{font-size:24px;font-weight:700;padding:0;margin:0}.home--article2,.home--heading2{font-family:Open Sans,sans-serif;color:#000}.home--article2{font-size:14px;margin-top:20px}.home--heading3{font-size:18px;font-weight:700;padding:0;margin:0}.home--article3,.home--heading3{font-family:Open Sans,sans-serif;color:#000}.home--article3{font-size:14px;margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/components/home/home.styl
// module id = 613
// module chunks = 0